export const SORT_BY_OPTIONS = [
  { value: 'MOST_RECENT', label: 'Most Recent' },
  { value: 'HIGHEST_COMPENSATION', label: 'Highest Compensation' },
  { value: 'LARGEST_CONTRACT', label: 'Largest Contract Value' },
  { value: 'EARLIEST_START_DATE', label: 'Earliest Start Date' },
  { value: 'MOST_FTES', label: 'Most FTEs' },
];

export const FIT_POLL_INTERVAL_MS = 10_000;
export const FIT_MAX_POLLS = 6;
// The Buying tab shows its last results again, without a refetch, for this long.
export const SEARCH_FRESH_MS = 5 * 60 * 1000;
